module.exports = __webpack_public_path__ + "static/media/15UN-Habitat6.a2c1fbf3.jpg";